import React from 'react';
import { AddNote, type AddNotePayload } from '@tviklax/ui-components';
import { SchedulingAddNoteProps } from './SchedulingContextTypes';

export const SchedulingAddNote: React.FC<SchedulingAddNoteProps> = ({
  orderId,
  currentStage,
  currentHealth,
  timestamp,
  currentUser,
  onSave,
  onCancel,
}) => {
  const handleAddNote = (payload: AddNotePayload) => {
    // Transform AddNotePayload to AddNotePayload with scheduling context
    onSave?.({
      orderId,
      currentStage,
      currentHealth,
      timestamp,
      author: payload.author || currentUser,
      noteType: payload.noteType,
      content: payload.content,
      impactLevel: payload.impactLevel,
      delay: payload.delay,
      delayCustom: payload.delayCustom,
      affectsStage: payload.affectsStage,
      visibility: payload.visibility,
      riskCause: payload.riskCause,
      notifications: payload.notifications,
      nextAction: payload.nextAction,
      nextActionDueBy: payload.nextActionDueBy,
      attachments: payload.attachments,
    } as any);
  };

  return (
    <AddNote
      title="Add Note to Order"
      subtitle="Capture operational changes, risks, and milestones. Control visibility and notify stakeholders."
      contextFields={{
        'Order ID': orderId,
        Stage: currentStage,
        Health: currentHealth.charAt(0).toUpperCase() + currentHealth.slice(1),
        Timestamp: new Date(timestamp).toLocaleString(),
      }}
      currentUser={currentUser}
      onSave={handleAddNote}
      onCancel={onCancel}
      showNextAction={true}
      showAttachments={true}
      showRootCause={true}
    />
  );
};
